import type { ReconciledStatusDetail } from '@app/application/solid/services/reconciled-status-service'

import { Controller } from '@hotwired/stimulus'

import reconciledStatusService, {
  RECONCILED_STATUS_EVENT,
} from '@app/application/solid/services/reconciled-status-service'

export default class extends Controller {
  static targets = ['reconciled', 'unreconciled']
  static values = {
    reconciliationTextId: Number,
    onlyReconciledWithData: Boolean,
  }

  private reconciledTarget!: HTMLElement
  private unreconciledTarget!: HTMLElement
  private reconciliationTextIdValue!: number
  private hasReconciliationTextIdValue!: boolean
  private onlyReconciledWithDataValue!: boolean

  connect(): void {
    // The SPA may have emitted before this controller connected; the service
    // buffers the latest status so it can be replayed here.
    const buffered = reconciledStatusService().lastKnownDetail
    if (buffered) {
      this.applyStatus(buffered)
    }

    document.addEventListener(RECONCILED_STATUS_EVENT, this.updateStatus)
  }

  disconnect(): void {
    document.removeEventListener(RECONCILED_STATUS_EVENT, this.updateStatus)
  }

  private updateStatus = (event: Event): void => {
    this.applyStatus((event as CustomEvent<ReconciledStatusDetail>).detail)
  }

  // Mirrors the only_reconciled_with_data clause of
  // ReconciliationText::Renderer#reconciled_for_ledger?, not its other clause.
  private applyStatus({
    reconciled: criterion,
    hasTextProperties,
  }: ReconciledStatusDetail): void {
    const reconciled =
      criterion &&
      !(this.onlyReconciledWithDataValue && hasTextProperties === false)
    this.reconciledTarget.classList.toggle('tw-hidden', !reconciled)
    this.unreconciledTarget.classList.toggle('tw-hidden', reconciled)
    this.publishToOverviewNavigation(reconciled)
  }

  // The SPA reports this status to the browser only. The sidebar shows statuses
  // from the server, so send it this one on the channel Liquid templates use.
  private publishToOverviewNavigation(reconciled: boolean): void {
    if (!this.hasReconciliationTextIdValue) {
      return
    }

    window.eventHub.$emit('sf-recon-status-updated', {
      itemClass: 'reconciliation_text',
      itemId: this.reconciliationTextIdValue,
      reconciled,
    })
  }
}
